import { NavigationExtras, Router } from '@angular/router';

export interface NavigationNotice {
  key: string;
  params?: Record<string, unknown>;
  variant?: 'success' | 'error';
}

export function noticeState(notice: NavigationNotice): NavigationExtras {
  return { state: { notice } };
}

export function readNavigationNotice(router: Router): NavigationNotice | null {
  const navigation = router.currentNavigation();
  // Beim Neuladen stellt Angular den alten history.state wieder her; der Hinweis gilt aber nur direkt nach der Aktion.
  if (!navigation?.previousNavigation) {
    return null;
  }
  const notice = (navigation.extras.state as { notice?: Partial<NavigationNotice> } | undefined)?.notice;
  if (typeof notice?.key !== 'string') {
    return null;
  }
  return notice as NavigationNotice;
}
